import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService, IdDescription } from '../../../tms-shared';
import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class ProductTypeAdditionalProductCostReferenceService extends BaseReferenceService {
  constructor(protected httpService: HttpService) {
    super('ProductTypeAdditionalProductCostReference', httpService);
  }

  getAll(): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetAll`);
  }

  getForProductType(productType: string): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/ProductType?productType=${productType}`);
  }
}
